var map = {
	"./EyeInvisible-open.svg": "./src/icons/svg/EyeInvisible-open.svg",
	"./EyeInvisible.svg": "./src/icons/svg/EyeInvisible.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./shop.svg": "./src/icons/svg/shop.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";